import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import VueLazyload from 'vue-lazyload'
import baseUtil from '@/utils/base'
import utils from '@/utils/utils'
import * as filters from './filters'
import PlatformLogo from './components/common/PlatformLogo/PlatformLogo'
import CancelOrderPopup from '@/components/common/CancelOrderPopup/CancelOrderPopup.vue'
import SegementLine from '@/components/puppetComponent/SegementLine'
import SohoBadge from '@/components/common/SohoBadge/SohoBadge'
import HowToSearchPopup from '@/components/common/HowToSearchPopup/HowToSearchPopup'

// register global utility filters.
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
import { Button, Tabbar, TabItem, Cell, InfiniteScroll, Navbar, TabContainer, TabContainerItem, Radio, Badge, Swipe, SwipeItem, Search, Lazyload, Popup, Picker, Field, Actionsheet } from 'mint-ui'

import { Toast, Dialog, Image as VanImage } from 'vant'
Vue.use(Dialog)
Vue.use(VanImage)

let mintUIComponents = [Button, Tabbar, TabItem, Cell, Navbar, TabContainer, TabContainerItem, Radio, Badge, Swipe, SwipeItem, Search, Popup, Picker, Field, Actionsheet]
mintUIComponents.forEach((item) => {
  Vue.component(item.name, item)
})
Vue.use(InfiniteScroll)
Vue.use(Lazyload)
Vue.component('plat-formLogo', PlatformLogo)
Vue.component('cancel-order-popup', CancelOrderPopup)
Vue.component('segement-line', SegementLine)
Vue.component('soho-badge', SohoBadge)
Vue.component('how-to-search-popup', HowToSearchPopup)

// 全局的事件总线
Vue.prototype.$EventBus = new Vue()

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@/assets/image/loadfail.png'),
  loading: require('@/assets/image/loading.png'),
  attempt: 1
})

Vue.prototype.$utils = utils

Vue.prototype.$toast = Toast

let getSignatureInfoApi = false

var position = 0

router.beforeEach((to, from, next) => {
  // 统计代码
  // _hmt.push(['_trackPageview', pageURL]) 必须是以"/"（斜杠）开头的相对路径
  if (to.path) window._hmt.push(['_trackPageview', '/#' + to.fullPath])
  /**
   * 分享相关：
   * wx.config方法：同一个url仅需调用一次，对于变化url的SPA的web app可在每次url变化时进行调用
   * 微信ios版：每次切换路由url不会变，调用一次config即可
   * 微信Android版：每次切换路由url会变，url变化须重新调用config（发起签名的url请求参数必须是当前页面的url）
   * Android微信客户端不支持pushState的H5新特性，所以路由模式必须为hash模式，此问题会在Android6.2中修复
   */

  try {
    if (baseUtil.isIOS()) {
      if (!getSignatureInfoApi) {
        position = 'before signature api --ios'
        baseUtil.signatureInfoApi().then(() => {
          getSignatureInfoApi = true
          menuHandler(to.name)
        })
      } else {
        menuHandler(to.name)
      }
    }
    if (!baseUtil.isIOS()) {
      position = 'before signature api --android'
      baseUtil.signatureInfoApi().then(() => {
        getSignatureInfoApi = true
        menuHandler(to.name)
      })
    }
    // google分析统计单页应用
    // eslint-disable-next-line
    if (gtag && to.path) gtag('config', process.env.VUE_APP_GA_URL, { page_path: to.path })
  } catch (error) {
    baseUtil.setErrorLog({
      errType: '分享出错 || 统计出错',
      errMsg: error,
      position: position,
      isCodeErr: true
    })
    next()
  }
})

const showMenuRouterNameList = ['unSearchDetail', 'goodsDetail', 'cashGiftGoodsDetail']

function menuHandler(routerName) {
  if (showMenuRouterNameList.indexOf(routerName) !== -1) {
    if (baseUtil.isIOS()) {
      position = 'show menu --ios'
    } else {
      position = 'show menu --android'
    }
    baseUtil.showMenuItems()
  } else {
    if (baseUtil.isIOS()) {
      position = 'hide menu --ios'
    } else {
      position = 'hide menu --android'
    }
    baseUtil.hideMenuItems()
  }
}

Vue.config.productionTip = false

import { SHOP_TYPE, PLATFORM_TYPE, PLATFORM_SHOP_TYPE, PLATFORM_TYPE_DETAIL, SHOP_TYPE_2, SEARCH_TYPE, USER_TYPE } from '@/constants/index'
Vue.prototype.SHOP_TYPE = SHOP_TYPE
Vue.prototype.PLATFORM_TYPE = PLATFORM_TYPE
Vue.prototype.PLATFORM_SHOP_TYPE = PLATFORM_SHOP_TYPE
Vue.prototype.PLATFORM_TYPE_DETAIL = PLATFORM_TYPE_DETAIL
Vue.prototype.SHOP_TYPE_2 = SHOP_TYPE_2
Vue.prototype.SEARCH_TYPE = SEARCH_TYPE
Vue.prototype.USER_TYPE = USER_TYPE

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

document.addEventListener('UniAppJSBridgeReady', function() {
  Vue.prototype.$uni = window.uni
})
